import { render, staticRenderFns } from "./VehicleInformationForm.vue?vue&type=template&id=6aeb9496&"
import script from "./VehicleInformationForm.vue?vue&type=script&lang=js&"
export * from "./VehicleInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports